import type { Interval, RestKline } from './binance';
import { INTERVAL_MS } from './binance';

export const DEMO_SYMBOLS = ['BTCUSDT','ETHUSDT','SOLUSDT','BNBUSDT','XRPUSDT','DOGEUSDT','ADAUSDT','LINKUSDT','AVAXUSDT','DOTUSDT'];
const BASE: Record<string, number> = { BTCUSDT:68000,ETHUSDT:3500,SOLUSDT:145,BNBUSDT:580,XRPUSDT:.62,DOGEUSDT:.14,ADAUSDT:.46,LINKUSDT:16,AVAXUSDT:35,DOTUSDT:7 };
export const demoBase = (symbol:string) => BASE[symbol] ?? 100;
/** Stable synthetic history, shared across symbols/timeframes; no network requests. */
export function demoCandles(symbol:string, interval:Interval, end=Date.now(), count=600): RestKline[] {
  const duration=INTERVAL_MS[interval], endBar=Math.floor(end/duration)*duration;
  const base=demoBase(symbol), phase=DEMO_SYMBOLS.indexOf(symbol)*.8;
  const value=(time:number)=>base*(1+Math.sin(time/4200000+phase)*.018+Math.sin(time/730000+phase)*.006+Math.sin(time/139000)*.002);
  return Array.from({length:count},(_,i)=>{
    const time=endBar-(count-1-i)*duration;
    const o=value(time), c=value(Math.min(time+duration,end));
    const noise=base*(.0004+Math.abs(Math.sin(time))*.0015);
    const volume=(20+Math.abs(Math.sin(time/87000))*80)*68000/base;
    return [time,''+o,''+(Math.max(o,c)+noise),''+(Math.min(o,c)-noise),''+c,''+volume,time+duration-1,''+(volume*c),120,''+(volume*.52),''+(volume*c*.52),'0'];
  });
}
